/* eslint-disable */
import { FIELD } from "@/data/constants";

export default [
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_saregodvs_number",
    label: "Licence number",
    fieldRequired: true,
    validation: { required: true },
    hint: "Enter all letters and numbers as they appear on the licence."
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_saregodvs_cardnumber",
    label: "Card number",
    fieldRequired: true,
    validation: { required: true },
    hint: "Enter all letters and numbers as they appear on the licence."
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_saregodvs_givenname",
    label: "First name",
    fieldRequired: true,
    hint: "Enter exactly as it appears on your licence (e.g. Helen)."
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_saregodvs_middlename",
    label: "Middle name (optional)",
    hint: "Enter exactly as it appears on your licence.",
    validation: { regex: /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/ }
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_saregodvs_surname",
    label: "Last name",
    fieldRequired: true,
    hint: "Enter exactly as it appears on your licence (e.g. Chan)."
  },
  {
    fieldType: FIELD.TEXT.FIELDDATEHEADING,
    label: "Date of birth",
    fieldRequired: true
  },
  {
    fieldType: FIELD.INPUT.DATE,
    name: "greenid_saregodvs_dob",
    label: "Date of birth",
    disabled: true,
    hint: "For example, 31 3 1979",
    validation: { required: true },
    fromYear: 1900,
    toYear: 2021
  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.INPUT.CHECK,
    name: "greenid_saregodvs_tandc",
    label: "Authorisation/Consent",
    validation: { required: true },
    options: [
      {
        value: "on",
        text: "I confirm that I am authorised to provide the personal details presented and I consent to my information being checked with the document issuer or official record holder via third party systems for the purpose of confirming my identity."
      }
    ]
  }
];
